module.exports = __webpack_public_path__ + "static/media/ChatLogo.955fb105.png";